import * as React from 'react';
import { trackInteraction } from '@reverbdotcom/commons/dist/tracker';
import bind from '@reverbdotcom/commons/dist/bind';

interface Props {
  type: string;
  link: string;
  socialShareSource?: string;
  icon?: string;
}

export default class SocialLink extends React.Component<Props, {}> {
  @bind
  trackClick() {
    trackInteraction({
      componentName: 'SocialLink',
      type: 'socialLinks',
      url: this.props.link,
    });
  }

  icon() {
    return this.props.icon || this.props.type;
  }

  render() {
    return (
      <a
        href={this.props.link}
        onClick={this.trackClick}
        target="_blank" rel="noopener noreferrer"
      >
        <span className={`share-${this.props.type} no-icon-bg`}>
          <span className={`fa fa-${this.icon()}`} />
        </span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/social_link.tsx